function Results({ mode, numberOfQuestion, numberOfCorrectAnswers, onRetry }) {
  if (mode === "good") {
    return (
      <div className="flex flex-col items-center justify-center w-full h-screen gap-8">
        <h2 className="text-3xl font-bold text-center text-primary">
          🎉 Congratulations!
        </h2>
        <div className="text-xl font-bold text-center text-green-600">
          {numberOfCorrectAnswers} / {numberOfQuestion} correct answers. Well
          done!
        </div>
        <div className="flex flex-col items-center w-full gap-8">
          <button
            className="px-8 py-3 text-center text-white border-2 rounded-full border-blue bg-blue hover:bg-blue/80"
            type="button"
            onClick={onRetry}
          >
            Play again?
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex flex-col items-center justify-center w-full h-screen gap-8">
        <h2 className="text-3xl font-bold text-center text-primary">
          😕 Better luck next time!
        </h2>
        <div className="text-xl font-bold text-center text-secondary">
          {numberOfCorrectAnswers} / {numberOfQuestion} correct answers, You can
          do better! <br />
          Would you like to try again?
        </div>
        <div className="flex flex-col items-center w-full gap-8">
          <button
            className="px-8 py-3 text-center text-white border-2 rounded-full border-blue bg-blue hover:bg-blue/80"
            type="button"
            onClick={onRetry}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
}

export default Results;
